import { MonitorStop } from "lucide-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { XktContext } from "../../Context/XktContext/XktContextProvider";
import { Toggle } from "../ui/toggle";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

interface Canvas {
    canvas: HTMLCanvasElement;
}
interface Scene {
    canvas: Canvas;
}

const SnapshotMaker = () => {
    const { state } = useContext(XktContext);
    const { t } = useTranslation();
    const takeSnapshot = () => {
        if (state.viewer == null) return;
        const scene = state.viewer.scene as unknown as Scene;
        const canvas = scene.canvas.canvas;

        const imageData = state.viewer.getSnapshot({
            format: "png",
            width: canvas.width,
            height: canvas.height,
        });

        //download imagedata
        const a = document.createElement("a");
        a.href = imageData;
        a.download = "screenshot.png";
        a.click();
        const myInterval = setInterval(() => {
            const removeCanvases = Array.from(document.querySelectorAll("canvas")).filter((x) => x.id === "");
            if (removeCanvases.length > 0) {
                removeCanvases.forEach((c) => {
                    //c.remove();
                });
                clearInterval(myInterval);
            }
        }, 10);
    };
    return (
        <>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className="inline-flex">
                        <Toggle
                            value="strikethrough"
                            aria-label={t("takeScreenshotAriaLabel")}
                            className="mr-1"
                            pressed={false}
                            onClick={takeSnapshot}
                        >
                            <MonitorStop className="h-4 w-4" />
                        </Toggle>
                    </span>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{t("takeScreenshot")}</p>
                </TooltipContent>
            </Tooltip>
        </>
    );
};

export default SnapshotMaker;
